"use strict";
exports.__esModule = true;
exports.INCOME_VERIFICATION_AMOUNT_LOCAL_STORAGE = exports.INCOME_BELOW_THRESHOLD = exports.WHAT_COUNTS_AS_INCOME = exports.INCOME_AMOUNT = void 0;
exports.INCOME_AMOUNT = {
    HEADER: 'What’s your annual income?',
    BODY: 'We need some additional information to consider your application. ',
    BODY_BOLD: 'Please provide your income for a full year.',
    INPUT_LABEL: 'Annual income',
    WHAT_COUNTS: 'What counts as income?',
    CTA: 'Continue',
    MIN_INCOME_THRESHOLD: 10000
};
exports.WHAT_COUNTS_AS_INCOME = {
    HEADER: 'What counts as income?',
    BODY_1: 'Your annual gross income includes what you earn from:',
    BULLETS: [
        'Employment',
        'Investments',
        'Retirement',
        'Social security benefits',
        'Public assistance',
        'Any money deposited directly into your account (individual or joint)',
        'If you are 21 or over, you may also include the amount of someone else’s income that is regularly used to pay your expenses',
    ],
    BODY_2: 'Alimony, child support, or separate maintenance income shouldn’t be included unless relied upon for credit.',
    CTA: 'Close'
};
exports.INCOME_BELOW_THRESHOLD = {
    HEADER: 'Is {{incomeAmount}} your income for the whole year?',
    BODY: 'You won’t be able to change it once you confirm.',
    CANCEL: 'Go back',
    CTA: 'Confirm amount'
};
exports.INCOME_VERIFICATION_AMOUNT_LOCAL_STORAGE = 'flexapp/income-verification-amount';
